const API_URL = `${process.env.REACT_APP_API_URL}`;

export const fetchQuickLinkGroups = async (accessToken: string,tenantID : number) => {
  try {
    const response = await fetch(
      `${API_URL}${process.env.REACT_APP_QUICKLINK_GROUPS_API}?tenantId=${tenantID}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch users.");
    }

    return response.json();
  } catch (error) {
    throw error;
  }
};

// Add User Group function
export const addQuickLinkGroups = async (
  quickLinkGroup: any,
  accessToken: string,
  tenantID : number
) => {
  try {
    const response = await fetch(
      `${API_URL}${process.env.REACT_APP_QUICKLINK_GROUPS_ADD_API}?tenantId=${tenantID}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(quickLinkGroup),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to add user group.");
    }

    const text = await response.text();
    try {
      return JSON.parse(text); // Return parsed JSON if valid
    } catch {
      console.warn("Server response is not valid JSON:", text);
      return text; // Return plain text as fallback
    }
  } catch (error) {
    throw error;
  }
};

// Update User Group function
export const updateQuickLinkGroups = async (
  quickLinkGroup: any,
  accessToken: string,
  tenantID : number
) => {
  try {
    const response = await fetch(
      `${API_URL}${process.env.REACT_APP_QUICKLINK_GROUPS_UPDATE_API}?tenantId=${tenantID}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(quickLinkGroup), // Send the whole quickLink object
      }
    );

    if (!response.ok) {
      throw new Error("Failed to update user group.");
    }

    const text = await response.text();
    try {
      return JSON.parse(text); // Return parsed JSON if valid
    } catch {
      console.warn("Server response is not valid JSON:", text);
      return text; // Return plain text as fallback
    }
  } catch (error) {
    throw error;
  }
};

// Delete User Group function
export const deleteQuickLinkGroups = async (
  quickLinkGroupID: number,
  accessToken: string,
  tenantID : number,
  DeletedBy : number
) => {
  try {
    const apiUrl = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_QUICKLINK_GROUPS_DELETE_API}?quickLinksGroupId=${encodeURIComponent(quickLinkGroupID)}&tenantId=${tenantID}&deletedBy=${DeletedBy}`;
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to delete user group.");
    }

    const text = await response.text();
    try {
      return JSON.parse(text); // Return parsed JSON if valid
    } catch {
      console.warn("Server response is not valid JSON:", text);
      return text; // Return plain text as fallback
    }
  } catch (error) {
    throw error;
  }
};
